import { Badge, Box } from '@chakra-ui/react';
import React from 'react';
import { RenderIf } from '../RenderIf/RenderIf';
import { PhotoSize } from '../../../types/enums/PhotoSize';
import useStyling from '../../../hooks/useStyling';
import PhotoWrapper from '../Photos/PhotoWrapper';
const PhotoGridItem = (props) => {
    const { photoItem: styles } = useStyling();
    const itemSizeSmall = '106px';
    const itemSizeLarge = '225px';
    const useLarge = props.shouldIncreaseSize && props.photoCount === 1;
    const showBadge = props.photoCount > props.maxToShow && !!props.canShowBadge;
    const additionalPhotos = props.photoCount - props.maxToShow;
    return (React.createElement(Box, { sx: styles, "data-testid": "photo-grid-item", h: !useLarge ? itemSizeSmall : itemSizeLarge, w: !useLarge ? itemSizeSmall : itemSizeLarge, onClick: props.clickHandler, onKeyDown: (e) => props.keyDownHandler(e), tabIndex: 0, ...props },
        React.createElement(PhotoWrapper, { photo: props.photo, isShare: props.isShare, shouldLoad: props.shouldLoad, loadedPhoto: props.loadedPhoto, key: props.photo.id, borderRadius: styles.borderRadius, size: !useLarge ? PhotoSize.SMALL : PhotoSize.MEDIUM }),
        React.createElement(RenderIf, { condition: showBadge },
            React.createElement(Badge, { onClick: (event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    props.onOpenAtStart();
                }, "data-testid": "photo-grid-item__additional-badge", sx: styles.badge, zIndex: 2, variant: "dark-grey" },
                "+",
                additionalPhotos))));
};
export default React.memo(PhotoGridItem);
